import { Box, Button, Grid2, Typography, useMediaQuery, useTheme } from "@mui/material";
import { useQuery } from "@tanstack/react-query";
import { useNavigate } from "react-router-dom";
import { fetchFeaturedCreators } from "../../utils/api";
import Lottie from "lottie-react";
import LoadingFace from '../../assets/animations/LoadingFace.json';
import FanCreatorProfileItem from "../fanCreatorList/fanCreatorProfileItem";


const ExpertAIPersonas: React.FC = () => {
  const theme = useTheme();
  const navigate = useNavigate();
  const md = useMediaQuery(theme.breakpoints.up("md"));
  const lg = useMediaQuery(theme.breakpoints.up("lg"));

  const { data: creators, isLoading } = useQuery({
    queryKey: ['featured-creators'],
    queryFn: async () => {
      return await fetchFeaturedCreators()
        .then((res) => {
          if (res.ok) {
            return res.json();
          } else {
            return {data: []}
          }
        })
        .catch((err) => {
          console.log(err)
          return {data: []}
        })
    },
    staleTime: Infinity,
  })

  return (
    <Box
      display='flex'
      flexDirection='column'
      width='100%'
      px={{xs: 2.5, md: 5}}
      py={{xs: 3, md: 4}}
      pt={{xs: 0, md: 4}}
      gap={{xs: 3, }}
      sx={{
        maxWidth: "lg",
      }}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: 2,
        }}
      >
        <Box
          width='100%'
          display='flex'
          flexDirection='column'
          textAlign="center"
        >
          <Typography
            variant='h5'
          >
            Explore AI Personas
          </Typography>
          <Typography
            variant='body1'
            color="text.secondary"
          >
            Chat with the AI Personas of leading experts and knowledge-workers in
            various fields of expertise.
          </Typography>
        </Box>
        <Button
          variant="contained"
          size="large"
          fullWidth={false}
          color="secondary"
          sx={{
            width: 'fit-content',
          }}
          onClick={() => {navigate('/creators')}}
          href='/creators'
        >
          Explore All Experts
        </Button>
      </Box>
      {
        isLoading ?
        <Box
          margin='auto'
          marginTop={1}
          sx={{
            '& path': {
              fill: (theme) => theme.palette.primary.main
            }
          }}
        >
          <Lottie
            animationData={LoadingFace}
            loop={true}
            style={{
              width: '100px',
              height: '100px',
            }}
          />
        </Box> :
        <Grid2
          container
          rowSpacing={{xs: 1, sm: 0.5, md: -1}}
          columnSpacing={0}
          sx={{
            mx: {
              xs: -1.5
            },
          }}
        >
          {
            creators.data.map((creatorItem, index) => {
              let limit = 4;
              if (lg) limit = 8;
              else if (md) limit = 6;
              return (
                <Grid2
                  size={{
                    xs: 6,
                    md: 4,
                    lg: 3
                  }}
                  sx={{
                    display: index+1 > limit ? 'none' : 'flex'
                  }}
                  key={index}
                >
                  <FanCreatorProfileItem profileData={creatorItem} />
                </Grid2>
              )
            })
          }
        </Grid2>

      }
    </Box>
  )
}

export default ExpertAIPersonas;
